import {
  useState,
  useEffect,
  Table,
  message,
  Checkbox,
  Button,
  Dashboard,
  axios,
  swal,
  DatePicker,
  moment,
  exportFromJSON,
  Papa,
  UploadOutlined,
} from "./import";
import { DownloadOutlined } from "@ant-design/icons";
import { api } from "../../../config";
import ReactLoading from "react-loading";

const { RangePicker } = DatePicker;
const TinUnFreeze = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [tinCount, setTinCount] = useState("");
  const [defaultDate, setDefaultDate] = useState([]);

  const [csvFile, setCSVFile] = useState(null);
  const [error, setError] = useState("");
  const [load, setLoad] = useState(false);

  const popup = (e) => {
    if (e === "noFile") {
      message.warn("Please Select a file", 5);
    }
  };

  const disabledDate = (current) => {
    // 90 DAYS GAP AND DISABLE TOMORROW
    return (
      // current.isBefore(moment().subtract(90, "day")) ||
      // current > moment().endOf("day")
      current && current > moment().endOf("day")
    );
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    console.log("date is ", value, dateString);
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  useEffect(() => {
    getUnfeezeTinList();
  }, [currentPage]);

  const onClickUnFreezeTin = (record) => {
    console.log("Button clicked for record:", record);
    if (selectedIds.length === 0) {
      message.error("Please select TIN Id!", 5);
    } else {
      swal({
        title: "Are You sure",
        text: `Do you really want to Un-Freeze ${selectedIds.length} Ids`,
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .put(
              "/manageTin/unFreezeTinList",
              {
                userId: localStorage.getItem("user.id"),
                tinListId: selectedIds,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("user.token")}`,
                },
              }
            )
            .then((res) => {
              message.success("TIN Ids Un-Freezed Successfully!", 5);
              setSelectedIds([]);
              getUnfeezeTinList();
            });
        } else {
          //swal("Your TIN Id is safe!");
        }
      });
    }
  };

  const columns = [
    {
      title: "Assign User Name",
      dataIndex: "assignUserName",
      key: "assignUserName",
    },
    {
      title: "Upload User Name",
      dataIndex: "uploadUserName",
      key: "uploadUserName",
    },
    {
      title: "tinNo",
      dataIndex: "tinNo",
      key: "tinNo",
    },
    {
      title: "tinType",
      dataIndex: "tinType",
      key: "tinType",
    },
    {
      title: "tinStatus",
      dataIndex: "tinStatus",
      key: "tinStatus",
    },
    {
      title: "RequestReason",
      dataIndex: "RequestReason",
      key: "RequestReason",
    },
    {
      title: "Assign Date",
      dataIndex: "assignDate",
      key: "assignDate",
    },
    {
      title: "Used Date",
      dataIndex: "usedDate",
      key: "usedDate",
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (text, record) => (
    //     <Button onClick={() => onClickUnFreezeTin(record)}>Un-Freeze</Button>
    //   ),
    // },
  ];

  const getUnfeezeTinList = () => {
    setLoading(true);
    axios
      .get(
        `/manageTin/unFreeze/usedTinList?PageNo=${currentPage}&PageSize=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        setTinCount(res.data.getTinListCount);
        const data = res?.data?.tinList.map((obj) => {
          const {
            assignUserId: { _id: assignUserId, name: assignUserName },
            // candidateId: { _id: candidateId, name: candidateName },
            uploadUserId: {
              _id: uploadUserId,
              name: uploadUserName,
              email: uploadUserEmail,
            },
            ...rest
          } = obj;
          return {
            assignUserId,
            assignUserName,
            //candidateId,
            //candidateName,
            uploadUserId,
            uploadUserName,
            uploadUserEmail,
            ...rest,
          };
        });
        console.log("datsttsts", data);
        const datas = data.map((ele) => {
          return {
            ...ele,
            assignDate: ele?.assignDate ? formatDate(ele.assignDate) : "",
            usedDate: ele?.usedDate ? formatDate(ele?.usedDate) : "",
            tinStatus: ele.tinStatus ? "Active" : "inActive",
          };
        });
        setData(datas);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleSelectionChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    const selectedIds = selectedRows.map((row) => row._id);
    setSelectedIds(selectedIds);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: handleSelectionChange,
  };

  const pagination = {
    current: currentPage,
    pageSize: pageSize,
    total: tinCount,
  };

  const exportType = "csv";
  const downloadSingleUserReport = () => {
    setLoad(true);
    axios
      .get(
        `/manageTin/Reports/DownloadUnFreezeLogs?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        const tinFormat = res?.data?.unFreezeTinList?.map((ele) => {
          return {
            name: ele?.UserId?.name,
            role: ele?.UserId?.role,
            email: ele?.UserId?.email,
            tin: ele?.TinId?.tinNo,
            tinType: ele?.TinId?.tinType,
            TIN_status: ele?.TinId?.tinStatus ? "Active" : "inActive",
            createdAt: ele?.createdAt ? formatDate(ele?.createdAt) : "",
            updatedAt: ele?.updatedAt ? formatDate(ele?.updatedAt) : "",
          };
        });
        let fileName = `TIN_RELEASE_REPORT_${moment(new Date()).format(
          "DD-MM-YYYY_HH:mm"
        )}`;
        let data = tinFormat;
        exportFromJSON({ data, fileName, exportType });
      })
      .finally((res) => {
        setLoad(false);
      });
  };

  function formatDate(d) {
    let date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d =
      dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCSVFile(file);
    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const headers = results.meta.fields;
        const isValid = headers.length === 2 && headers.includes("tinNo") && headers.includes("tinType");
        if (isValid) {
          console.log("Headers are valid!");
          setError("");
          setCSVFile(file);
        } else {
          message.warn("Headers are Not valid!");
          setError("Headers are Not valid!");
        }
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (csvFile) {
      if (error) {
        message.warn("Headers are Not valid!");
      } else {
        setLoad(true);
        var data = new FormData();
        data.append("", csvFile);

        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `manageTin/Bulk/unFreezeTinList/${localStorage.getItem(
            "user.id"
          )}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
          data: data,
        };

        axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
            swal({
              title: `${response.data.status}`,
              icon: "success",
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                window.location.reload();
              }
            });
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            // setTimeout(()=>{
            //   window.location.reload()
            // },2000)
            setLoad(false);
          });
      }
    } else {
      popup("noFile");
    }
  };

  return (
    <Dashboard title="TIN Release">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row m-0 bg-white cursor-pointer p-3 border mb-2 d-flex align-items-center justify-content-between">
        <div className="col-md-6 align-items-center mb-1">
          <p htmlFor="csv-file" className="mr-1 mb-0">
            <label className="mb-0">Bulk Release (CSV file) :</label>
          </p>
          <input
            type="file"
            id="csv-file"
            accept=".csv"
            onChange={handleFileChange}
          />
          <button className="btn btn-primary mr-4 mt-1" onClick={handleSubmit}>
            <i class="fa fa-upload" aria-hidden="true"></i>
          </button>
          <button
            className="btn btn-primary mt-1"
            onClick={() => onClickUnFreezeTin("record")}
          >
            Release
          </button>
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          <RangePicker
            format="YYYY-MM-DD"
            defaultValue={[moment(), moment()]}
            onChange={handleDate}
            // onOk={onOk}
            disabledDate={disabledDate}
            placeholder={[
              moment(new Date()).format("YYYY-MM-DD"),
              moment(new Date()).format("YYYY-MM-DD"),
            ]}
          />
          <button
            className="btn mx-3 btn-primary"
            onClick={downloadSingleUserReport}
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <Table
        className="border"
        scroll={{
          x: 1300,
        }}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey="_id"
      />
    </Dashboard>
  );
};

export default TinUnFreeze;
